export const images = {
  eiLogo: "/img/logo-ei.png",
  dovetailLogo: "/img/logo-dovetail.png",
  imiLogo: "/img/logo-imi.png",
  programOverview: "/img/programme-overview.png",
  spotlight: "/img/spotlight.jpg",
  preReadingImgUrl: "/img/preReadingThumb.png",
  workshopTemplatesImgUrl: "/img/workshopTemplates.png",
  workshopMaterialsImgUrl: "/img/workshopMaterials.png",
  strategyClarificationWorkshopImgUrl: "/img/strategyClarificationWorkshop.png",
};
